module.exports = __webpack_public_path__ + "img/bg.93ac1d23.png";